import { SYS_COLOR_TEXT_DISPLAY_DEFAULT_DARK, SYS_SPACE_FIXED_200 } from '@oneaudi/unified-web-alpha-common';
import styled from 'styled-components';

export const StyledKeyFactsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${SYS_SPACE_FIXED_200};
`;

export const DriveTrainKeyfactStyle = styled.div`
	display: flex;
	flex-direction: column-reverse;

	.value {
		color: ${SYS_COLOR_TEXT_DISPLAY_DEFAULT_DARK};
	}
`;
